// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3dacI","buttons":"RemoveExpirationActionButtons_buttons__8fe3r"};